module.exports = __webpack_public_path__ + "static/media/leaseInactive.a4a19578.png";